import { memo } from 'react';
import { NodePanelProps } from '../../types';
import { LargeModelExtractionNodeType } from './types';
import PanelForm from './form';

const LargeModelExtractionPanel = ({
  id,
  formRef,
  ...props
}: NodePanelProps<LargeModelExtractionNodeType>) => {
  return <PanelForm {...props} ref={formRef} />;
};

export default memo(LargeModelExtractionPanel);
